/**
 * Created by piotr.pozniak@thebeaverhead.com on 11/07/2022
 */

/**
 *
 * @param String anchor
 */
export const getLinkFromAnchor = (anchor) => {
  const container = document.createElement("div");
  container.innerHTML = anchor.trim();

  const aTag = container.firstChild;

  if (!aTag) {
    return null;
  }

  let labelTag = document.createElement("div");
  labelTag.innerHTML = aTag.innerHTML;
  const label = labelTag.innerText || aTag.href;

  return {
    url: aTag.href,
    label,
  };
};

const urlRegex =
  /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

/**
 * Linkify text. Finds all urls in text and wraps them in anchor tags
 * @param text
 * @returns {*}
 */
export const linkify = (text) => {
  // replace url with anchor tag in text only if the url is not already wrapped in an anchor tag
  const container = document.createElement("div");
  container.innerHTML = text;

  // Regex to match URLs (excluding emails)
  // the regex below does not work on older Safari as it does nto support reverse look-up
  // const urlRegex = /(?<!@)(?:(?:https?:\/\/)|(?:www\.))(([\w-]+\.)+\w{2,})([\/\w*\+\-_]*)?(\?[^\s<>"]*)?/gi;

  const urlRegex =
    /(?:^|[^@])(?:(?:https?:\/\/)|(?:www\.))(([\w-]+\.)+\w{2,})([\/\w*\+\-_]*)?(\?[^\s<>"]*)?/gi;

  // Recursive function to walk through text nodes
  function walk(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const replaced = text.replace(urlRegex, (url) => {
        // Don't double-wrap, only raw URLs
        const href = url.trim().startsWith("http")
          ? url
          : "https://".concat(url);
        return `<a href="${href.trim()}" target="_blank" rel="noopener noreferrer">${url.trim()}</a>`;
      });

      if (replaced !== text) {
        const span = document.createElement("span");
        span.innerHTML = replaced;
        node.replaceWith(...span.childNodes);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "A") {
      // Avoid walking inside <a> tags
      Array.from(node.childNodes).forEach(walk);
    }
  }

  walk(container);
  return container.innerHTML;

  /*  text.replace(
    /(?:http([s]?):\/\/)?((([\w-]+[.])+\w{2,})([\/\w*\+-_])*(\?[^\s]*)*)(?!.*>)/
  );
  text.replace(
    /(?<!@)(?:(?:https?:\/\/)|(?:www\.))((([\w-]+\.)+\w{2,})([\/\w*\+\-_]*)?(\?[^\s]*)*)(?!.*>)/
  );
  return text.replace(
    /(?<!@)(?:(?:https?:\/\/)|(?:www\.))((([\w-]+\.)+\w{2,})([\/\w*\+\-_]*)?(\?[^\s]*)*)(?!.*>)/gi,
    // /<a href="http$1://$2">$2</a>/
    (m, p1, p2) => {
      console.log("linkify", m, p1, p2);
      const httpsPrefix = m.includes("http") ? "" : "https://";
      const finalUrl = `${httpsPrefix}${m}`;
      return `<a href="${finalUrl}">${finalUrl}</a>`;
    }
  );*/
};

/**
 * Get links from description
 * @param description
 * @returns {*[]|*[{url: *, label: *}]}
 */
export const getLinksFromDescription = (description) => {
  if (!description) {
    return [];
  }

  const dom = document.createElement("div");
  dom.innerHTML = description;
  const anchorNodes = dom.querySelectorAll("a");

  let descriptionAnchors = [];

  if (anchorNodes.length) {
    anchorNodes.forEach((anchor) => {
      descriptionAnchors.push(anchor.outerHTML);
    });
  } else {
    descriptionAnchors = description.match(
      /(<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>)/g
    );
  }

  // ignore links to youtube or vimeo
  if (descriptionAnchors) {
    descriptionAnchors = descriptionAnchors.filter(
      (anchor) =>
        !anchor.match(
          /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/
        ) && !anchor.match(/(?:vimeo\.com\/|video\/)(\d+)/)
    );
  }

  const links =
    descriptionAnchors && descriptionAnchors.length
      ? [descriptionAnchors[0]]
      : [];

  if (descriptionAnchors && descriptionAnchors.length > 1) {
    links.push(descriptionAnchors.splice(-1)[0]);
  }

  const firstLink = links[0] ? getLinkFromAnchor(links[0]) : null;
  const lastLink = links[1] ? getLinkFromAnchor(links[1]) : null;

  return [firstLink, lastLink];
};

export const getImageFromImageTag = (tag) => {
  const container = document.createElement("div");
  container.innerHTML = tag.trim();

  const imgTag = container.firstChild;

  if (!imgTag) {
    return null;
  }

  return {
    url: imgTag.src,
    label: imgTag.title || imgTag.alt || "",
  };
};

/**
 *
 * @param description
 * @returns {*|*[]}
 */
export const getImagesFromDescription = (description) => {
  if (!description) {
    return [];
  }
  const descriptionImages = description.match(
    /<img\s+[^>]*src="([^"]*)"[^>]*>/g
  );
  if (!descriptionImages) {
    return [];
  }
  return descriptionImages.map((img) => {
    return getImageFromImageTag(img);
  });
};
